import {Link} from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {email_support} from "../common/constants";
import NavigationHeader from "./Layout/NavigationHeader";
import {downloadProtectedFile} from "../common/BackendConnections";
import {filename_session_checklist, filename_checkin_before, filename_checkin_after} from "../common/constants"

const HelpCenter = (props) => {
  const accordionStyle = {
    backgroundColor: "#f3f5f9",
    marginTop: "2ch"
  }

  return (
    <div className={"page_content"}>
      <NavigationHeader />

      <div>
        <h1>Help Center</h1>
        <section className={"section"}>
          <h2>Frequently Asked Questions</h2>
          <Accordion style={accordionStyle} classes="help-accordion" defaultExpanded={false}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="help-panel1-content">
              <h5>What do I do if I have trouble pairing?</h5>
            </AccordionSummary>
            <AccordionDetails id={"help-panel1-content"}>
              <div>
                <p>
                  If you're having trouble pairing a remote virtual reality headset to the clinician dashboard, there are a few additional steps you can take to troubleshoot the issue:
                </p>

                <ol>
                  <li>1. Check that the remote headset is properly charged and turned on.</li>
                  <li>2. Ensure that the remote headset and clinician dashboard are both connected to the internet.</li>
                  <li>3. Make sure that the remote headset is properly configured and set up to connect to the clinician
                  dashboard.</li>
                  <li>4. Check that the firewall settings on the network allow communication between the remote
                  headset and the clinician dashboard.</li>
                  <li>5. Restart both the remote headset and the clinician dashboard.</li>
                  <li>6. If possible, try connecting the remote headset to a different network to see if the issue persists.</li>
                </ol>

                <span>
                  If you've tried these steps and are still experiencing issues, it may be helpful to consult the user manual or contact the manufacturer or technical support for further assistance.
                </span>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion style={accordionStyle} defaultExpanded={false}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="help-panel2-content">
              <h5>How do I read patient data?</h5>
            </AccordionSummary>
            <AccordionDetails id={"help-panel2-content"}>
              <div>
                <p>
                  The process for reading patient data from the clinician dashboard may vary depending on what device the dashboard software being used. However, in general, the following steps may apply:
                </p>
              </div>

              <ol>
                <li>1. Log in to the clinician dashboard with your username and password.</li>
                <li>2. Navigate to the patient data section of the dashboard.</li>
                <li>3. Identify the patient whose data you would like to view.</li>
                <li>4. Click on the patient's name to access their data.</li>
                <li>5. Review the patient's data, which may include demographic information, medical history,
              current medications, test results, and other relevant information.</li>
                <li>6. Use the dashboard's search and filter functions to locate specific information within the
              patient's data.</li>
                <li>7. If necessary, export the patient's data into a report or other format for further analysis or
              sharing with other healthcare providers.</li>
              </ol>

              <p>
                It's important to follow any applicable privacy and security protocols when accessing patient data and to ensure that you have the necessary permissions and authorizations to view and work with patient data within the clinician dashboard. If you are unsure about how to use the dashboard or have any concerns about patient data privacy or security, consult with the appropriate authorities or technical support personnel.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion style={accordionStyle} defaultExpanded={false}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="help-panel3-content">
              <h5>How do I pair the Head Mounted Display (HMD)?</h5>
            </AccordionSummary>
            <AccordionDetails id={"help-panel3-content"}>
              <div>
                <p>
                  The process for pairing a Head Mounted Display (HMD) may vary depending on the specific device and software being used. However, in general, the following steps may apply:
                </p>
              </div>

              <ol>
                <li>1. Ensure that the HMD is fully charged and turned on.</li>
                <li>2. Make sure that the HMD is in pairing mode. This may involve pressing a specific button or combination of buttons,
                or activating a pairing mode through the HMD's software settings.</li>
                <li>3. On the device or software that you want to pair the HMD with, navigate to the Bluetooth or wireless settings.</li>
                <li>4. Search for available Bluetooth or wireless devices.</li>
                <li>5. Select the HMD from the list of available devices.</li>
                <li>6. Follow any additional prompts or instructions to complete the pairing process.</li>
              </ol>

              <p>
                Once the HMD is paired with the device or software, it should be able to communicate and share data wirelessly. It's important to ensure that the HMD and device or software are compatible with each other and that any necessary updates or drivers are installed before attempting to pair them. Additionally, be sure to follow any safety and usage instructions provided by the manufacturer for the HMD and the device or software being used.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion style={accordionStyle} defaultExpanded={false}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="help-panel4-content">
              <h5>Where can I find the high stress points of the patient?</h5>
            </AccordionSummary>
            <AccordionDetails id={"help-panel4-content"}>
              <div>
                <p>
                  However, some possible locations to look for high stress points in a patient's report include:
                </p>
              </div>

              <ul>
                <li>Patient surveys or self-reports: Some patient surveys or self-reports may include questions or scales that assess stress levels or stress-related symptoms. Look for sections of the report that summarize the patient's responses to these questions or scales.</li>
                <li>Analytics or data visualizations: The dashboard will generate visualizations or analytics that highlight areas of high stress or risk. Look for sections of the report that include these types of data visualizations or analytics, and pay attention to any areas that are highlighted as high-risk or high-stress.</li>
              </ul>

              <p>
                If you're having trouble locating high stress points in a patient's report, it may be helpful to consult with the healthcare provider or clinician who generated the report, or to seek guidance from technical support personnel for the software or system being used.
              </p>
            </AccordionDetails>
          </Accordion>
        </section>

        <section className={"section"}>
          <h2>Print Out Support Forms</h2>
          <div><Link onClick={()=>downloadProtectedFile('session_checklist', filename_session_checklist)}>
            Daily Session Checklist</Link></div>
          <div><Link onClick={()=>downloadProtectedFile('checkin_before', filename_checkin_before)}>
            Check in with Patient before VR</Link></div>
          <div><Link onClick={()=>downloadProtectedFile('checkin_after', filename_checkin_after)}>
            Check in with Patient after VR</Link></div>
        </section>

        <section className={"section"}>
        <h2>Support Documents</h2>
          <div><Link to={"/missing/"}>Game User Guides</Link></div>
          <div><Link to={"/missing/"}>Pairing Troubleshooting</Link></div>
          <div><Link to={"/missing/"}>About Unlimited Therapeutics</Link></div>
        </section>

        <div style={{marginTop: "1.5rem"}}>
        For more resources <Link to={"/missing/"}>click here</Link><br/>
        Please contact our support at <a href={`mailto:${email_support}`}>{email_support}</a> for further assistance
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;
